export enum RequirementType {
    AMOUNT = 1,
    QUANTITY = 2,
}

